<div class="row align-items-center">
  <div class="col-md-10 col-10 col-md-10">
    @if (!loading) {
      <select [(ngModel)]="basket" class="form-control" (change)="selectBasket($event)">
        @for (basket of baskets; track basket) {
          @if (!basket.pre_order && !basket.locked) {
            <option [value]="basket.id">{{basket.name}}</option>
          }
        }
      </select>
    }
  </div>
  <div class="col-md-2 col-2 col-md-2 ps-0 d-flex align-items-center">
    <i class="material-icons clickable withOpacity" (click)="newBasket()">add_circle</i>
  </div>
</div>
